export const findCurrency = (global: Window = window) => {
    const container = global.document.querySelector('[data-currency-iso-code]');
    if (container) {
        return container.getAttribute('data-currency-iso-code');
    }
    return null;
};
